import styled from 'styled-components';
import { pxToRem } from '../../../foundation/spacing/utils.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

var sizeToPx = {
  small: 20,
  medium: 24
};
var StyledButton = styled.button.withConfig({
  displayName: "StyledButton",
  componentId: "sc-gv4miq-0"
})(["display:flex;justify-content:center;align-items:center;width:", ";height:", ";background-color:", ";border:", " solid ", ";border-radius:", ";outline:", " solid transparent;transition:outline 0.1s ease-in-out;&:focus-visible{box-shadow:0 0 0 ", " ", ";}&:hover:not(:disabled){background-color:", ";}&:active:not(:disabled){outline:", " solid ", ";&:disabled{opacity:0.5;}"], function (_ref) {
  var $size = _ref.$size;
  return pxToRem(sizeToPx[$size]);
}, function (_ref2) {
  var $size = _ref2.$size;
  return pxToRem(sizeToPx[$size]);
}, function (_ref3) {
  var $selected = _ref3.$selected;
  return $selected ? themeGet('colors.primary.1000') : themeGet('colors.primary.0');
}, pxToRem(1), function (_ref4) {
  var $selected = _ref4.$selected;
  return $selected ? themeGet('colors.border.300') : themeGet('colors.border.200');
}, themeGet('borderRadius.circle'), pxToRem(0), pxToRem(4), themeGet('colors.focus.primary'), function (_ref5) {
  var $selected = _ref5.$selected;
  return $selected ? themeGet('colors.primary.800') : themeGet('colors.primary.200');
}, pxToRem(2), themeGet('colors.primary.100'));

export { StyledButton };
